import { getServerUrl } from './copyToClipboard';

import Types from '../modules/types';

export default function getStoreUrl(store, to) {
  return (
      store.domains && store.domains[0]
    ? `https://${store.domains[0]}${to || ''}`
    : `${getServerUrl()}/${store.slug}${to || ''}`
  );
}

export function getProductsUrl(store, productSlug, variationSlug, search) {
  return getStoreUrl(store, `/${
    Types.SHOP_PRODUCTS_ARCHIVE_PATH
  }${
    productSlug ? `/${productSlug}` : ''
  }${
    variationSlug ? `/${variationSlug}` : ''
  }${
    search || ''
  }`);
}
